import React from 'react';

const styles = {
  container: {
    width: '100%',
    margin: '0 auto',
    padding: '16px',
  },
  mapContainer: {
    width: '100%',
  },
  mapTitle: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '8px',
  },
  iframe: {
    border: 0,
    width: '100%',
    height: '360px',
    display: 'block',
  },
};

const ShowroomAccessMap = ({ title = 'アクセスマップ', embedUrl }) => {
  if (!embedUrl || !embedUrl.includes('google.com/maps/embed')) return null;

  return (
    <div style={styles.container}>
      <div style={styles.mapContainer}>
        <h1 style={styles.mapTitle}>{title}</h1>
        <iframe
          title={title}
          src={embedUrl}
          style={styles.iframe}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
};

export default ShowroomAccessMap;
